import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Box, Divider, Tab, Tabs, Typography } from '@mui/material'

import CatalogDiscount from './components/CatalogDiscount'
import CommercialsEdit from './components/CommercialsEdit'
import { EditTdpDocuments } from './components/DocumentsEdit'
import RebateEdit from './components/RebateEdit'
// import CatalogDiscount from './components/CatalogDiscount'
// import Commercials from './components/Commercials'
// import { UploadTdpDocuments } from './components/Documents'
// import Rebate from './components/Rebate'
import TDPDetailsEdit from './components/TDPDetailsEdit'

export interface TenantDetails {
  tenantId: string
  name: string
  currency: string
}
function TDPEdit() {
  const location = useLocation()
  const navigate = useNavigate()

  const currentTab = location.hash || '#details'

  const handleTabChange = (_, newValue) => {
    navigate({
      pathname: location.pathname,
      search: location.search, // keeps ?id=...
      hash: newValue // e.g. '#commercials'
    })
  }

  return (
    <Box>
      <Box
        sx={{
          background: '#000869',
          padding: '15px',
          borderRadius: '10px'
        }}
      >
        <Typography variant='h4' color='#fff'>
          TDP Edit
        </Typography>
      </Box>

      <Box sx={{ width: '100%', mt: '30px' }}>
        <Tabs
          value={currentTab}
          onChange={handleTabChange}
          aria-label='hash navigation tabs'
          sx={{ width: '100%' }}
        >
          <Tab label='TDP Details' value='#details' sx={{ width: '20%' }} />
          <Tab
            label='Catalog & Discount'
            value='#catalogDiscount'
            sx={{ width: '20%' }}
          />
          <Tab label='Commercials' value='#commercials' sx={{ width: '20%' }} />
          <Tab label='Rebate' value='#rebate' sx={{ width: '20%' }} />
          <Tab label='Documents' value='#documents' sx={{ width: '20%' }} />
        </Tabs>
      </Box>

      <Divider />

      <Box sx={{ width: '100%', mt: '30px' }}>
        {currentTab == '#details' && <TDPDetailsEdit />}
        {currentTab == '#catalogDiscount' && <CatalogDiscount />}
        {currentTab == '#commercials' && <CommercialsEdit />}
        {currentTab == '#rebate' && <RebateEdit />}

        {currentTab == '#documents' && <EditTdpDocuments />}
      </Box>
    </Box>
  )
}

export default TDPEdit
